var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg07(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_360",
    "data-name": "Grupo 360",
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.047,
    height: 56.567,
    viewBox: "0 0 56.047 56.567",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_359",
    "data-name": "Grupo 359",
    transform: "translate(26.294 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_199",
    "data-name": "Trazado 199",
    d: "M346.626,749.173a16.762,16.762,0,0,1,13.647,13.646,1.747,1.747,0,0,0,1.73,1.458,2.44,2.44,0,0,0,.3-.027,1.759,1.759,0,0,0,1.445-2.031,20.261,20.261,0,0,0-16.511-16.509,1.768,1.768,0,0,0-2.031,1.431A1.738,1.738,0,0,0,346.626,749.173Z",
    transform: "translate(-345.179 -734.498)",
    fill: "#85d4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_200",
    "data-name": "Trazado 200",
    d: "M374.724,765.8a33.363,33.363,0,0,0-27.186-27.187,1.755,1.755,0,1,0-.573,3.464,29.8,29.8,0,0,1,24.3,24.3,1.748,1.748,0,0,0,1.732,1.458,2.393,2.393,0,0,0,.3-.027A1.724,1.724,0,0,0,374.724,765.8Z",
    transform: "translate(-344.998 -738.581)",
    fill: "#85d4ff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_201",
    "data-name": "Trazado 201",
    d: "M344.943,768.494a47.752,47.752,0,0,0,11.562,10.52,17.57,17.57,0,0,0,1.6.872c.468.235.912.457,1.288.691.054.025.105.064.157.09a2.658,2.658,0,0,0,3.267-.571l4.453-4.454a2.95,2.95,0,0,1,1.967-.976,2.655,2.655,0,0,1,1.875.951l.025.025,7.175,7.175c1.34,1.327,1.34,2.7.013,4.075-.013,0-.013.013,0,0-.507.546-1.028,1.042-1.589,1.589a34.454,34.454,0,0,0-2.513,2.6,6.276,6.276,0,0,1-4.9,2.071c-.2,0-.4,0-.6-.014a28.24,28.24,0,0,1-10.157-3.047,57.817,57.817,0,0,1-19.217-15.051,52.874,52.874,0,0,1-9.375-15.612,18.589,18.589,0,0,1-1.458-8.15,5.979,5.979,0,0,1,1.8-3.867l4.44-4.44a2.953,2.953,0,0,1,1.979-.924,2.779,2.779,0,0,1,1.9.912l.039.038c.794.743,1.549,1.511,2.343,2.332.4.416.82.833,1.238,1.263l3.555,3.554c1.379,1.381,1.379,2.656,0,4.037-.378.376-.743.754-1.121,1.119-1.093,1.12-2.135,2.162-3.267,3.177-.027.025-.052.038-.066.065a2.658,2.658,0,0,0-.677,2.955l.039.117",
    transform: "translate(-328.48 -736.588)",
    fill: "#85d4ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg07);
export default __webpack_public_path__ + "static/media/07.87133e5a65cc0aa0d38d19a31ab42219.svg";
export { ForwardRef as ReactComponent };